import { apiget, apipost, apidel } from "../../api";

/**
 * @type {string[]}
 */
export const KV_LIST = [
  "roles",
  "statuts",
  "fonctions",
  "typologies",
  "programs",
  "missions",
  "labels",
  "awards",
  "normes",
  "dates",
  "procedures",
  "diplomas",
  "axes",
  "surfaces"
];

/**
 *
 * @type {{fonctions: string, missions: string, awards: string, roles: string, procedures: string, typologies: string, dates: string, programs: string, statuts: string, normes: string, labels: string}}
 */
export const KV_LIST_FRENCH = {
  roles: "rôles",
  statuts: "statuts",
  fonctions: "fonctions",
  typologies: "typologies",
  programs: "programmes",
  missions: "missions",
  labels: "labels",
  awards: "récompenses",
  normes: "normes",
  dates: "dates",
  procedures: "procédures",
  diplomas: "diplômes",
  axes: "axes",
  surfaces: "surfaces"
};

export const types = {
  GET_KV: "GET_KV",
  SEARCH_KV: "SEARCH_KV",
  ADD_KV: "ADD_KV",
  DELETE_KV: "DELETE_KV",
  GET_KV_BY_ID: "GET_KV_BY_ID",
  GET_KV_STACK: "GET_KV_STACK",
  MERGE_KV: "MERGE_KV"
};

export const actions = {
  [types.GET_KV]: token => async (_, type) =>
    await apiget(`/kv/${type}`, {}, token),
  [types.SEARCH_KV]: token => async (_, { type, query }) =>
    await apiget(`/kv/${type}/search/${query}`, {}, token),
  [types.ADD_KV]: token => async (_, { type, name }) =>
    await apipost(`/kv/${type}`, { name }, token),
  [types.DELETE_KV]: token => async (_, { type, id }) =>
    await apidel(`/kv/${type}/${id}`, {}, token),
  [types.GET_KV_BY_ID]: token => async (_, { type, id }) =>
    await apiget(`/kv/${type}/${id}`, {}, token),
  [types.GET_KV_STACK]: token => async (_, { type, ids }) =>
    await apiget(`/kvs/${type}/${ids.join(",")}`, {}, token),
  [types.MERGE_KV]: token => async (_, { type, ids, replacement }) =>
    await apipost(`/kvs/merge`, { type, ids, replacement }, token)
};
